import React from 'react';
import Head from 'next/head';
import { Card, CardContent } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Accordion from '../components/molecules/Accordion';

const FAQ = () => {
  const { t } = useTranslation('common');
  return (
    <div className="faq">
      <Head>
        <title>{t('title.faq')}</title>
        <meta name="description" content={t('description.faq')} />
      </Head>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="mt-12 mb-24 text-wrap">
          <h1 className="text-3xl mb-8">{t('service.faq.title')}</h1>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-8">
              <section className="faq-section mb-24">
                <h2 className="text-xl">{t('service.faq.general.title')}</h2>
                <Accordion title={t('service.faq.general.q1')}>
                  <p>{t('service.faq.general.a1')}</p>
                </Accordion>
                <Accordion title={t('service.faq.general.q2')}>
                  <p>{t('service.faq.general.a2')}</p>
                </Accordion>
                <Accordion title={t('service.faq.general.q3')}>
                  <p>{t('service.faq.general.a3')}</p>
                </Accordion>
                <Accordion title={t('service.faq.general.q4')}>
                  <p>{t('service.faq.general.a4')}</p>
                </Accordion>
                <Accordion title={t('service.faq.general.q5')}>
                  <p>{t('service.faq.general.a5')}</p>
                </Accordion>
              </section>
              <section className="faq-section mb-24">
                <h2 className="text-xl">{t('service.faq.classes.title')}</h2>
                <Accordion title={t('service.faq.classes.q1')}>
                  <p>{t('service.faq.classes.a1')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q2')}>
                  <p>{t('service.faq.classes.a2')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q3')}>
                  <p>{t('service.faq.classes.a3')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q4')}>
                  <p>{t('service.faq.classes.a4')}</p>
                </Accordion>
                {/*
                <Accordion title={t('service.faq.classes.q5')}>
                  <p>{t('service.faq.classes.a5')}</p>
                </Accordion>
                */}
                <Accordion title={t('service.faq.classes.q6')}>
                  <p>{t('service.faq.classes.a6')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q7')}>
                  <p>{t('service.faq.classes.a7')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q8')}>
                  <p>{t('service.faq.classes.a8')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q9')}>
                  <p>{t('service.faq.classes.a9')}</p>
                </Accordion>
                <Accordion title={t('service.faq.classes.q10')}>
                  <p>{t('service.faq.classes.a10')}</p>
                </Accordion>
              </section>
              <section className="faq-section mb-24">
                <h2 className="text-xl">{t('service.faq.payment.title')}</h2>
                <Accordion title={t('service.faq.payment.q1')}>
                  <p>{t('service.faq.payment.a1')}</p>
                </Accordion>
                <Accordion title={t('service.faq.payment.q2')}>
                  <p>{t('service.faq.payment.a2both')}</p>
                </Accordion>
                <Accordion title={t('service.faq.payment.q3')}>
                  <p>{t('service.faq.payment.a3')}</p>
                </Accordion>
                <Accordion title={t('service.faq.payment.q4')}>
                  <p>{t('service.faq.payment.a4_1')}</p>
                  <p>{t('service.faq.payment.a4_2')}</p>
                  <ul className="list-unstyled mt-6">
                    <li>
                      <b>{t('service.faq.payment.a4_3_1')}</b>
                      <span> {t('service.faq.payment.a4_3_2')}</span>
                    </li>
                    <li>
                      <b>{t('service.faq.payment.a4_4_1')}</b>
                      <span> {t('service.faq.payment.a4_4_2')}</span>
                    </li>
                    <li>
                      <b>{t('service.faq.payment.a4_5_1')}</b>
                      <span> {t('service.faq.payment.a4_5_2')}</span>
                    </li>
                  </ul>
                </Accordion>
                <Accordion title={t('service.faq.payment.q5')}>
                  <p>{t('service.faq.payment.a5')}</p>
                </Accordion>
                <Accordion title={t('service.faq.payment.q6')}>
                  <p>{t('service.faq.payment.a6both')}</p>
                </Accordion>
                <Accordion title={t('service.faq.payment.q7')}>
                  <p>{t('service.faq.payment.a7')}</p>
                </Accordion>
                <Accordion title={t('service.faq.payment.q8')}>
                  <p>{t('service.faq.payment.a8')}</p>
                </Accordion>
              </section>
            </div>
            <div className="col-span-12 md:col-span-4">
              <Card className="bg-slate-50 border-0 shadow-none rounded-none">
                <CardContent>
                  <div>
                    <h3 className="mb-6">{t('service.faq.contactUs.title')}</h3>
                    <p>{t('service.faq.contactUs.intro')}</p>
                    <a href="mailto:support@lingualbox.com">
                      support@lingualbox.com
                    </a>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default FAQ;
